export const getCurrentUser = (state) => state.userOne.userInfo;
export const deleteUser = (state) => state.userOne.deleteUserSuccess;
export const putCurrentUser = (state) => state.userOne.putUserSuccess;
// export const postCurrentClient = (state) => state.userOne.postClientSuccess;